import {ApiConnection} from 'powtoon-api/src/apiConnection'

export interface TokenApiData {
  token: string
}
export const getApiSessionToken = (connection: ApiConnection) => () =>
  connection.get<TokenApiData>('account/api-session-token')

export const getApiUserIdToken = (connection: ApiConnection) => () =>
  connection.get<TokenApiData>('account/user-id-token')

export const getExportToApiApplication = (connection: ApiConnection) => (powtoonId: string) => {
  const formData = new FormData()
  formData.append('powtoon_id', powtoonId)

  return connection.post('export-to-api-application/', formData, {isFormData: true})
}
  